export const NOTIFICATIONS = {
	UserEmail: "user@example.com",
	NotificationSettings: {
		Setting1: true,
		Setting2: false,
		Setting3: true,
	},
};
export const NOTIFICATION_SETTINGS_TEXT = "Notification Settings";

export const NOTIFICATION_NAV_TEXT = "Notification Settings";
export const NOTIFICATION_NAV_ID = "notification_settings_breadcrumb";
export const ACCOUNT_NAV_TEXT = "Account";
export const ACCOUNT_NAV_ID = "account_breadcrumb";
